//Taken and modified from:
// https://github.com/jh3141/react-smooth-marquee/

import React, {Component} from "react";

interface IProps {
	velocity?: number;
}

export default class Marquee extends Component<IProps> {
	setOuterRef: (ref: any) => void;
	setContentRef: (ref: any) => void;
	tick: (timestamp: any) => void;
	tickRequested: boolean;
	lastTimestamp: any;

	mouseEnter: () => void;
	mouseLeave: () => void;

	x: number;

	outerDiv: HTMLElement;
	innerDiv: HTMLElement;

	animationRequest: number;

	constructor(props: IProps) {
		super(props);
	
		this.setOuterRef = this.setOuterRef_.bind(this);
		this.setContentRef = this.setContentRef_.bind(this);
		this.tick = this.tick_.bind(this);
		this.tickRequested = false;
		this.lastTimestamp = null;
		
		this.mouseEnter = this.mouseEnter_.bind(this);
		this.mouseLeave = this.mouseLeave_.bind(this);
		
		this.x = 0;
	}
	
	setOuterRef_(ref: Element) {
		this.outerDiv = ref as HTMLElement;
		this.start();
	}
	
	setContentRef_(ref: Element) {
		this.innerDiv = ref as HTMLElement;
		this.start();
	}
	
	start() {
		if (this.outerDiv && this.innerDiv && !this.tickRequested) {
			this.animationRequest = window.requestAnimationFrame(this.tick);
			this.tickRequested = true;
		}
	}
	
	stop() {
		// console.log("attempting to stop animation");
		if (this.outerDiv && this.innerDiv && this.tickRequested) {
			// this.lastTimestamp = window.performance && window.performance.now && window.performance.timing && window.performance.timing.navigationStart ? window.performance.now() + window.performance.timing.navigationStart : Date.now();
			// this.lastTimestamp = window.performance.now();
			window.cancelAnimationFrame(this.animationRequest);
			this.tickRequested = false;
		}
	}

	tick_(timestamp: any) {
		if (!this.outerDiv || !this.innerDiv) {
			// one or more components have been unmounted. stop animation
			// until they are remounted (if ever)
			this.tickRequested = false;
			return;
		}

		if (this.lastTimestamp !== null) {
			// console.log(timestamp, this.lastTimestamp);
			// this.updateAnimation(timestamp - this.lastTimestamp);
			this.updateAnimation(this.lastTimestamp);
		}

		this.lastTimestamp = 1000 / 60;
		// this.lastTimestamp = timestamp;
		this.animationRequest = window.requestAnimationFrame(this.tick);
		// this.lastTimestamp += 1 / 60;
		// this.lastTimestamp = timestamp;
	}
	
	updateAnimation(deltaT: number) {
		// console.log("uA");
		
		this.x -= deltaT * this.getVelocity();
		if (this.x + this.innerDiv.clientWidth < 0)
			this.x += this.innerDiv.clientWidth + this.outerDiv.clientWidth;
		this.innerDiv.style.transform = this.calculateTransform();
	}
	
	getVelocity() {
		return this.props.velocity ? this.props.velocity : 0.06;
	}
	
	render() {
		return <div className="Marquee" ref={this.setOuterRef}>
			<div className="MarqueeContent" 
				onMouseEnter={this.mouseEnter}
				onMouseLeave={this.mouseLeave}
				ref={this.setContentRef} style={{transform: this.calculateTransform()}}>
				{this.props.children}
			</div>
		</div>;
	}
	
	calculateTransform() {
		return "translateX(" + this.x + "px)";
	}
	
	mouseEnter_() {
		// console.log("mouseEnter");
		this.stop();
	}
	
	mouseLeave_() {
		// console.log("mouseLeave");
		this.start();
	}
}